import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Menu from './Menu';
import Rotte from './Rotte';

import { showError, fetchWithRetry } from '../utils';
import { setUserStatus, getUserStatus } from '../api';
import '../scss/index.scss';

import { useNavigate } from 'react-router-dom';

// Icone SVG
import { ReactComponent as IconStatusUnavailable } from '../assets/icons/status-unavailable.svg';
import { ReactComponent as IconStatusAvailable } from '../assets/icons/status-available.svg';
import { ReactComponent as IconStatusCheckCalendar } from '../assets/icons/status-check-calendar.svg';

import { ReactComponent as IconFooterLogoMenuBar } from '../assets/icons/menu-logo.svg';
import { ReactComponent as IconFooterMenuMenuBar } from '../assets/icons/menu-menu.svg';
import { ReactComponent as IconFooterAddressBookMenuBar } from '../assets/icons/menu-address-book.svg';
import { ReactComponent as IconFooterCallMenuBar } from '../assets/icons/menu-call.svg';
import { ReactComponent as IconFooterMessagesMenuBar } from '../assets/icons/menu-messages.svg';
import { ReactComponent as IconLoading } from '../assets/icons/spinner.svg';

const STATUS_MAP = {
    1: { class: 'unavailable', label: 'Non disponibile', Icon: IconStatusUnavailable },
    2: { class: 'available', label: 'Disponibile', Icon: IconStatusAvailable },
    3: { class: 'check-calendar', label: 'Disponibile secondo calendario', Icon: IconStatusCheckCalendar }
};

function StatusButton({ status, setStatus }) {

    const [loadingStatus, setIsLoadingStatus] = useState(false);
    const keys = Object.keys(STATUS_MAP).map(Number);

    const handleClick = async () => {
        setIsLoadingStatus(true);
        const currentIndex = keys.indexOf(status);
        const nextStatus = keys[(currentIndex + 1) % keys.length];
        try {
            const response = await setUserStatus(nextStatus);
            setStatus(nextStatus);
        } catch (err) {
            showError([err.message]);
        } finally {
            setIsLoadingStatus(false);
        }
    };

    const { class: statusClass, label, Icon } = STATUS_MAP[status] || STATUS_MAP[2];
    return (
        <div className="status-btn-container">
            <button className={`status-btn ${statusClass}`} onClick={handleClick} title={label}>
                {(loadingStatus || status === -1) ? <IconLoading className={`icon-loading ${statusClass}`}/> : <Icon className="icon" />}
                
            </button>
            <span className={`status-label ${statusClass}`}>
                {!(loadingStatus || status === -1) ? label : ''}
            </span>
        </div>
    );
}


function AppBarBtn({ icon: Icon, active, onClick }) {
    const btnClass = active ? 'AppBarBtn AppBarBtn-active' : 'AppBarBtn';
    return (
        <button className={btnClass} onClick={onClick}>
            <Icon className="AppBarIcon" />
        </button>
    );
}

function AppBar({ menuOpen, toggleMenu }) {

    const navigate = useNavigate();

    let items = [
        { key: 'chiamaeinoltra', icon: IconFooterAddressBookMenuBar },
        { key: 'call', icon: IconFooterCallMenuBar, onClick: () => window.location.href = `tel:${authData?.user?.num_tel_cliente || ''}` },
        { key: 'sendmessage', icon: IconFooterMessagesMenuBar }
    ];    

    const authData = useSelector(state => state.auth.authData);
    if ( ! authData?.user?.has_num_tel_cliente){
        items = items.filter(item => item.key !== 'call');        //rimuovo key=call
    }


    return (
        <nav className="app-bar">
            <IconFooterLogoMenuBar className="AppBarlogo" onClick={() => navigate("/")} />
            <div className="btns">
                <div className="btns_center">
                    {items.map(item => (
                        <AppBarBtn
                            key={item.key}
                            icon={item.icon}
                            onClick={item.onClick ? item.onClick : () => navigate(`/${item.key}`)}
                        />
                    ))}
                </div>
                <div className="dx">
                    <AppBarBtn
                        key="menu"
                        icon={IconFooterMenuMenuBar}
                        onClick={() => toggleMenu(!menuOpen)}
                    />
                </div>
            </div>
        </nav>
    );
}

function Header({disponibilita, setDisponibilita}) {
    const authData = useSelector(state => state.auth.authData);
    const userName = authData?.user?.name || 'Utente';

    return (
        <header className="header">
            <h2>
                Ciao <span className="username">{userName}</span>
            </h2>
            <StatusButton status={disponibilita} setStatus={setDisponibilita} />
        </header>
    );
}

export default function HomePage() {

    const [open, toggleMenu] = useState(false);
    const [disponibilita, setDisponibilita] = useState(-1);

    useEffect(() => {
        let ignore = false;
        async function fetchDisponibilita() {
            const userStatus = await getUserStatus();
            if (ignore) return;
            setDisponibilita(userStatus);
        }
        async function loadDisponibilita() {
            try {
                await fetchWithRetry(fetchDisponibilita, ignore );
            } catch (err) {
                if (ignore) return;
                console.log('Tutti i tentativi falliti:', err);
                showError(['Errore durante il recupero dello stato di disponibilità: ' + err.message]);
            }
        }

        loadDisponibilita();

        return () => {
            ignore = true;
        };
    }, []);

    return (
        <div className="app-container">
            <Header disponibilita={disponibilita} setDisponibilita={setDisponibilita}/>

            <main className="main-container">
               <Rotte/>
            </main>

            <AppBar menuOpen={open} toggleMenu={toggleMenu} />
            <Menu menuOpen={open} toggleMenu={toggleMenu} />
        </div>
    );
}